import React, { memo } from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import {
  FeaturesHorizontalCaption,
  FeaturesCaptionedImage,
  FeaturesSection,
  FeaturesSectionDescription,
  FeaturesSectionSubtitle,
  FeaturesSectionTitle,
} from '../../styles';

function FeaturesAnalyticsSectionView() {
  const t = useT();
  return (
    <FeaturesSection>
      <FeaturesSectionTitle>
        {t(
          'FeaturesScreen.FeaturesAnalyticsSection.Title',
          'Insightful and clear analytics from Spotify',
          'Anchor features page analytics section title'
        )}
      </FeaturesSectionTitle>
      <FeaturesCaptionedImage>
        <MarketingImage
          alt={t(
            'FeaturesScreen.FeaturesAnalyticsSection.AnalyticsImageAlt',
            'A woman looking at Anchor analytics on a desktop computer and the IAB 2.0 logo in the lower-right corner of the image',
            'Anchor features page analytics section image screenreader information'
          )}
          imagePath="features/analytics/analytics-data"
          width={970}
          height={545}
        />
        <FeaturesHorizontalCaption>
          <FeaturesSectionSubtitle>
            {t(
              'FeaturesScreen.FeaturesAnalyticsSection.Subtitle',
              'Accurate, reliable data—all in one place',
              'Anchor features page analytics section subtitle'
            )}
          </FeaturesSectionSubtitle>
          <FeaturesSectionDescription>
            {t(
              'FeaturesScreen.FeaturesAnalyticsSection.Description',
              'Detailed, IAB 2.0-certified metrics to better measure your audience and help your show grow are all available in a single dashboard.',
              'Anchor features page analytics section description'
            )}
          </FeaturesSectionDescription>
        </FeaturesHorizontalCaption>
      </FeaturesCaptionedImage>

      <FeaturesCaptionedImage>
        <MarketingImage
          alt={t(
            'FeaturesScreen.FeaturesAnalyticsSection.PerformanceImageAlt',
            'A graph from the Anchor analytics dashboard that shows the listenership of a podcast',
            'Anchor features page performance section image screenreader information'
          )}
          imagePath="features/analytics/analytics-tools"
          width={970}
          height={545}
          isDropShadowed={false}
        />
        <FeaturesHorizontalCaption>
          <FeaturesSectionSubtitle>
            {t(
              'FeaturesScreen.FeaturesAnalyticsSection.PerformanceTitle',
              'Performance tools to help you grow your audience',
              'Anchor features page performance section title'
            )}
          </FeaturesSectionSubtitle>
          <FeaturesSectionDescription>
            {t(
              'FeaturesScreen.FeaturesAnalyticsSection.PerformanceDescription',
              'Engagement insights help you see where your Spotify listeners are dropping off, so you can plan your podcast around the content that performs best.',
              'Anchor features page performance section description'
            )}
          </FeaturesSectionDescription>
        </FeaturesHorizontalCaption>
      </FeaturesCaptionedImage>

      <FeaturesCaptionedImage>
        <MarketingImage
          alt={t(
            'FeaturesScreen.FeaturesAnalyticsSection.ListenersImageAlt',
            'A graph from the Anchor analytics dashboard that shows audience breakdowns on aggregated age and gender',
            'Anchor features page listeners section image screenreader information'
          )}
          imagePath="features/analytics/analytics-insights"
          width={970}
          height={545}
          isDropShadowed={false}
        />
        <FeaturesHorizontalCaption>
          <FeaturesSectionSubtitle>
            {t(
              'FeaturesScreen.FeaturesAnalyticsSection.ListenersTitle',
              'Unique insights on your listeners',
              'Anchor features page listeners section title'
            )}
          </FeaturesSectionSubtitle>
          <FeaturesSectionDescription>
            {t(
              'FeaturesScreen.FeaturesAnalyticsSection.ListenersDescription',
              'Audience breakdowns on aggregated age, gender, geolocation, and listening apps help you learn more about your Spotify listeners, so you can better tailor your content.',
              'Anchor features page listeners section description'
            )}
          </FeaturesSectionDescription>
        </FeaturesHorizontalCaption>
      </FeaturesCaptionedImage>
    </FeaturesSection>
  );
}

export const FeaturesAnalyticsSection = memo(FeaturesAnalyticsSectionView);
